import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { notification } from 'antd';
import Router from './routes';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import EnvironmentConfig from './components/EnvironmentConfig';
import ErrorBoundary from './components/ErrorBoundary';
import './style/tailwind.css';

// Set global default duration for all notifications (5 seconds)
notification.config({
  placement: 'top',
  duration: 5,
});

export default function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <EnvironmentConfig />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <ThemeProvider>
            <ScrollToTop />
            <StyledChart />
            <Router history={Router} />
          </ThemeProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
